export default "__VITE_ASSET__17ecfa77__"